<script setup>
  const props = defineProps({ item: Object });
</script>

<template>
  <v-list-subheader class="cognito-navdrawer__header">{{ props.item.header }}</v-list-subheader>
</template>

<style lang="scss" scoped>
  @use '~/styles/navigation' as *;
</style>
